import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { FLOW_ID } from './AppConstants';

export const isValidPhone = (phone) => {
  const re = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/;
  const re1 = /^\d{10}$/;
  return re.test(phone) || re1.test(phone);
};

export const getOrgType = (currentFlow) => {
  if (currentFlow === FLOW_ID.PROVIDER) {
    return 'healthcare professional or facility';
  }
  if (currentFlow === FLOW_ID.BILLING) {
    return 'billing';
  }
  if (currentFlow === FLOW_ID.VENDOR) {
    return 'vendor';
  }
  return '';
};

export const adobeInteraction = (
  name,
  value,
  context,
  toggle,
  location,
  payload
) => {
  if (toggle) {
    adobeTaggingEvent('CTA_CLICKS', {
      name,
      value,
      context,
      location,
      payload,
    });
  }
};
